// Single source of truth for all photo albums.
// Adding a new album here automatically updates both the Photography page
// and the Latest Stills teaser on the Home page.
//
// teaserImages: 1–2 src strings to feature on the Home page grid.
// If omitted, the cover is used.

export const albums = [
  {
    id: 'continental-tires',
    title: 'Continental Tires',
    subtitle: 'Brand & Commercial',
    cover: '/images/continental-tires/CT1.jpeg',
    teaserImages: ['/images/continental-tires/CT1.jpeg', '/images/continental-tires/CT2.jpeg'],
    images: Array.from({ length: 13 }, (_, i) => ({
      src: `/images/continental-tires/CT${i + 1}.jpeg`,
      alt: `Continental Tires – ${i + 1}`,
    })),
  },
  {
    id: 'bts',
    title: 'Behind The Scenes',
    subtitle: 'On Set & Production',
    cover: '/images/bts/BTS2.jpg',
    teaserImages: ['/images/bts/BTS2.jpg', '/images/bts/BTS3.jpg'],
    images: [
      { src: '/images/bts/BTS1.jpg', alt: 'BTS – Jersey Joint / Belushi Shoot' },
      { src: '/images/bts/BTS2.jpg', alt: 'BTS – Pool Scum Shoot' },
      { src: '/images/bts/BTS3.jpg', alt: 'BTS – Ant Money / E-Town Shoot' },
      { src: '/images/bts/BTS4.jpg', alt: 'BTS – Camera Setup' },
      { src: '/images/bts/BTS5.jpg', alt: 'BTS – 5' },
      { src: '/images/bts/BTS6.jpg', alt: 'BTS – 6' },
    ],
  },
  {
    id: 'studio',
    title: 'Studio Sessions',
    subtitle: 'Artist Portraits & Sessions',
    cover: '/images/studio/Studio3.png',
    teaserImages: ['/images/studio/Studio3.png', '/images/studio/Studio7.png'],
    images: Array.from({ length: 10 }, (_, i) => ({
      src: `/images/studio/Studio${i + 1}.png`,
      alt: `Studio Session ${i + 1}`,
    })),
  },
  {
    id: 'thrillrot',
    title: 'ThrillRot EPK',
    subtitle: 'Event & Promo Coverage',
    cover: '/images/thrill-rot/thrillrot.jpg',
    teaserImages: ['/images/thrill-rot/thrillrot.jpg'],
    images: [
      { src: '/images/thrill-rot/thrillrot.jpg', alt: 'ThrillRot' },
      { src: '/images/thrill-rot/debut.jpg', alt: 'ThrillRot Debut' },
      { src: '/images/thrill-rot/promo1.jpg', alt: 'ThrillRot Promo 1' },
      { src: '/images/thrill-rot/promo2.jpg', alt: 'ThrillRot Promo 2' },
      { src: '/images/thrill-rot/promo3.jpg', alt: 'ThrillRot Promo 3' },
      { src: '/images/thrill-rot/promo4.jpg', alt: 'ThrillRot Promo 4' },
      { src: '/images/thrill-rot/promo5.jpg', alt: 'ThrillRot Promo 5' },
      { src: '/images/thrill-rot/promo6.jpg', alt: 'ThrillRot Promo 6' },
    ],
  },
  {
    id: 'filmwork',
    title: 'Film Work',
    subtitle: 'On Location Shoots',
    cover: '/images/film%20work/IMG_8317.JPG',
    teaserImages: ['/images/film%20work/IMG_8317.JPG', '/images/film%20work/IMG_8361.JPG'],
    images: [
      { src: '/images/film%20work/IMG_8317.JPG', alt: 'Film Work 1' },
      { src: '/images/film%20work/IMG_8318.JPG', alt: 'Film Work 2' },
      { src: '/images/film%20work/IMG_8361.JPG', alt: 'Film Work 3' },
      { src: '/images/film%20work/IMG_8362.JPG', alt: 'Film Work 4' },
      { src: '/images/film%20work/IMG_8366.JPG', alt: 'Film Work 5' },
      { src: '/images/film%20work/IMG_8367.JPG', alt: 'Film Work 6' },
      { src: '/images/film%20work/IMG_8368.JPG', alt: 'Film Work 7' },
      { src: '/images/film%20work/IMG_8369.JPG', alt: 'Film Work 8' },
      { src: '/images/film%20work/IMG_8370.JPG', alt: 'Film Work 9' },
      { src: '/images/film%20work/IMG_8371.JPG', alt: 'Film Work 10' },
      { src: '/images/film%20work/IMG_8372.JPG', alt: 'Film Work 11' },
      { src: '/images/film%20work/IMG_8373.JPG', alt: 'Film Work 12' },
      { src: '/images/film%20work/IMG_8374.JPG', alt: 'Film Work 13' },
      { src: '/images/film%20work/IMG_8375.JPG', alt: 'Film Work 14' },
      { src: '/images/film%20work/IMG_8376.JPG', alt: 'Film Work 15' },
    ],
  },
  {
    id: 'michael-petted',
    title: 'Michael Petted',
    subtitle: 'Survivor Music Video',
    cover: '/images/michael-petted/Survivor_1.jpg',
    teaserImages: ['/images/michael-petted/Survivor_1.jpg', '/images/michael-petted/Survivor_2.jpg'],
    images: [
      { src: '/images/michael-petted/Survivor_1.jpg', alt: 'Michael Petted – Survivor 1' },
      { src: '/images/michael-petted/Survivor_2.jpg', alt: 'Michael Petted – Survivor 2' },
      { src: '/images/michael-petted/Survivor_3.jpg', alt: 'Michael Petted – Survivor 3' },
      { src: '/images/michael-petted/Survivor_4.jpg', alt: 'Michael Petted – Survivor 4' },
    ],
  },
  {
    id: 'warped-tour',
    title: 'Warped Tour',
    subtitle: 'Epitaph Records Shoot',
    cover: '/images/warped-tour/wtour1.jpg',
    teaserImages: ['/images/warped-tour/wtour1.jpg', '/images/warped-tour/wtour6.JPG'],
    images: [
      { src: '/images/warped-tour/wtour1.jpg', alt: 'Warped Tour 1' },
      { src: '/images/warped-tour/wtour2.png', alt: 'Warped Tour 2' },
      { src: '/images/warped-tour/wtour3.gif', alt: 'Warped Tour 3' },
      { src: '/images/warped-tour/wtour5.png', alt: 'Warped Tour 5' },
      { src: '/images/warped-tour/wtour6.JPG', alt: 'Warped Tour 6' },
      { src: '/images/warped-tour/wtour7.JPG', alt: 'Warped Tour 7' },
      { src: '/images/warped-tour/wtour8.gif', alt: 'Warped Tour 8' },
      { src: '/images/warped-tour/wtour9.png', alt: 'Warped Tour 9' },
      { src: '/images/warped-tour/wtour10.jpg', alt: 'Warped Tour 10' },
      { src: '/images/warped-tour/wtour11.jpg', alt: 'Warped Tour 11' },
    ],
  },
  {
    id: 'secretstash',
    title: 'The Secret Stash',
    subtitle: "Kevin Smith's Comic Book Shop",
    cover: '/images/secretstash/Still%202026-04-10%20161838_1.1.1.jpg',
    teaserImages: [
      '/images/secretstash/Still%202026-04-10%20161838_1.1.1.jpg',
      '/images/secretstash/Still%202026-04-10%20161838_2.2.5.jpg',
    ],
    images: [
      // Group 1 — 23 shots
      ...Array.from({ length: 23 }, (_, i) => ({
        src: `/images/secretstash/Still%202026-04-10%20161838_1.1.${i + 1}.jpg`,
        alt: `The Secret Stash – ${i + 1}`,
      })),
      // Group 2 — 42 shots (no _2.2.24 file)
      ...Array.from({ length: 43 }, (_, i) => {
        const n = i + 1;
        if (n === 24) return null;
        return {
          src: `/images/secretstash/Still%202026-04-10%20161838_2.2.${n}.jpg`,
          alt: `The Secret Stash – ${n}`,
        };
      }).filter(Boolean),
      // Group 3 — 6 shots
      ...Array.from({ length: 6 }, (_, i) => ({
        src: `/images/secretstash/Still%202026-04-10%20161838_3.1.${i + 1}.jpg`,
        alt: `The Secret Stash – ${i + 1}`,
      })),
    ],
  },
];
